import {loadLocationsByTypeName} from '../../api/geosimepar/loadLocations';

const state = {
  fountains: [],
  receivingBodies: [],
};

const mutations = {
  setFountains(state, data) {
    state.fountains = data ? data : [];
  },
  setReceivingBodies(state, data) {
    state.receivingBodies = data ? data : [];
  },
};

const actions = {
  async loadFountains({commit}, payload) {
    const {customer_id} = payload;

    try {
      const {data} = await loadLocationsByTypeName('pontocaptacao');
      const fountains = data.features.map((feature) => {
        const {cptsia, citname, sistema, cptnome, cptlocationref} =
          feature.properties;
        const formatSystemName = sistema ? sistema : 'sem sistema associado';
        return {
          locationid: cptlocationref,
          customerid: customer_id,
          locationname: `SIA - ${cptsia} - ${citname} - ${formatSystemName} - ${cptnome}`,
        };
      });
      commit('setFountains', fountains);
    } catch (error) {
      commit('setFountains', undefined);
    }
  },

  async loadReceivingBodies({commit}, payload) {
    const {customer_id} = payload;

    try {
      const {data} = await loadLocationsByTypeName('pontoreceptor');
      const receivingBodies = data.features.map((feature) => {
        const {rcpete, citname, rcpnome, rcplocationref} = feature.properties;
        return {
          locationid: rcplocationref,
          customerid: customer_id,
          locationname: `ETE - ${rcpete} - ${citname} - ${rcpnome}`,
        };
      });
      commit('setReceivingBodies', receivingBodies);
    } catch (error) {
      commit('setReceivingBodies', undefined);
    }
  },
};

const getters = {
  fountains: (state) => state.fountains,
  receivingBodies: (state) => state.receivingBodies,
};
export default {
  state,
  mutations,
  actions,
  getters,
};
